import {AEntity} from "./abstract/AEntity";

export interface IDirection {
    dirLib: string
    dirLibLong: string
    dirDesc: string
    dirType: string
}

export class Direction extends AEntity {
    dirLib: string
    dirLibLong: string
    dirDesc: string
    dirType: string

    constructor(direction: IDirection) {
        super();
        this.dirLib = direction.dirLib;
        this.dirLibLong = direction.dirLibLong;
        this.dirDesc = direction.dirDesc;
        this.dirType = direction.dirType;
    }

    getId(): string {
        return this.dirLib
    }

    toJSON(): IDirection {
        return {
            dirLib: this.dirLib,
            dirLibLong: this.dirLibLong,
            dirDesc: this.dirDesc,
            dirType: this.dirType,
        }
    }
}
